import { IntlMessage } from '$HVUI';
import Button from '$Molecules/Buttons/Button';

const NotYou = props => {
    const { email = '', name = '' } = props;

    if (!email || !name) return null;

    return (
        <Button
            element="link4"
            to="/logout"
            kind="secondary"
            text={
                <IntlMessage
                    id="all.not-email-name-log-out"
                    values={{ email: email, name: name }}
                />
            }
            style={{ marginTop: '2rem' }}
        />
    );
};

export default NotYou;
